import { all, fork } from 'redux-saga/effects';
// import watchDashboard from './containers/Dashboard/saga';

export function* rootSaga() {
  yield all([
    // fork(watchDashboard),
  ]);
}
